import { api } from "assets/scripts/utilities/api-clients";
import axios from "axios";

export const validateIfscRegex = (ifsc) => {
  const regex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;

  return regex.test(ifsc);
};

export const fetchBankDetailsFromIFSC = async (ifsc) => {
  try {
    const response = await axios.get(`https://ifsc.razorpay.com/${ifsc}`);

    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const index = async (options = {}) => {
  const response = await api.get(
    `kam/${options?.params?.applies_to}/banks`,
    options,
  );

  return response;
};

export const post = async (userId, payload, options) => {
  const response = await api.post(
    `/kam/banks/${userId}?PII=1`,
    payload,
    options,
  );

  return response;
};

export const putPrimary = async (userId, payload, options) => {
  const response = await api.put(
    `/kam/banks/primary/${userId}?PII=1`,
    payload,
    options,
  );

  return response;
};

export const get = async (userId) => {
  const response = await api.get(`/kam/banks/${userId}`);

  return response;
};

export const put = async (userId, payload, options) => {
  const response = await api.put(
    `/kam/banks/${userId}?PII=1`,
    payload,
    options,
  );

  return response;
};

export const remove = async (userId, payload) => {
  const response = await api.put(
    `/kam/remove/banks/${userId}?_id=${payload._id}&file_id=${payload.file_id}`,
  );

  return response;
};

export const verify = async (userId, payload) => {
  const response = await api.get(`/kam/verify/banks/${userId}/${payload._id}`);

  return response;
};

export const postVerifyBank = async (payload) => {
  const response = await api.post("/kam/verify_banks", payload);

  return response;
};

export const putPrimaryBank = async (userId, payload, options) => {
  const response = await api.put(
    `/kam/banks/${userId}/primary`,
    payload,
    options,
  );

  return response;
};
